import React, { ReactNode, Children } from 'react';
import styled from 'styled-components';
import flattenChildren from 'react-keyed-flatten-children';

import Box from 'libs/core-components/Box/Box';
import { spaces } from '@99designs/ui/settings';
import { ResponsiveProp } from 'libs/utils/responsiveProps';

interface Props {
    children: ReactNode;
    space: ResponsiveProp<spaces.Space>;
}

const BoxItem = styled(Box)`
    :last-child {
        padding-bottom: 0;
    }
`;

export default function Stack({ children, space }: Props) {
    const stackItems = flattenChildren(children);

    return (
        <Box>
            {Children.map(stackItems, (child) =>
                child !== null && child !== undefined ? (
                    <BoxItem paddingBottom={space}>{child}</BoxItem>
                ) : null
            )}
        </Box>
    );
}
